import * as React from "react"
import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[96px] w-full rounded-sm border border-rule bg-[rgba(255,252,244,0.7)] px-4 py-3 font-sans text-[14px] leading-[1.55] text-ink ring-offset-background transition placeholder:text-ink-soft/70 focus-visible:outline-none focus-visible:border-ink-soft focus-visible:ring-2 focus-visible:ring-gold-soft focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
